import { BlobPicture } from "./Picture";
import { PictureForWebClient } from "./PictureForWebClient";


export class PictureConverter
{
    public static Convert(picture: PictureForWebClient): BlobPicture
    {
        if (!picture)
        {
            return null;
        }

        const blob = new Blob([picture.Image], { type: 'image/jpeg' });

        return new BlobPicture(blob, picture.PictureTime, picture.IndexFromDevice, picture.Size);
    }

    public static ConvertBufferToBlob(buffer: ArrayBuffer): Blob
    {
        if (!buffer)
        {
            return null;
        }

        const blob = new Blob([buffer], { type: 'image/jpeg' });

        return blob;
    }
}
